import React from 'react';
import PropTypes from 'prop-types';
// Admin only
const AdminOnlyDetails = ({ c }) => {
  return (
    <>
      <p>
        <strong>Paid:</strong>{' '}
        {c?.paid ? 'User has paid for course' : 'Course was a gift'}
      </p>
      {c?.transactionId && (
        <p>
          <strong>Transaction Id:</strong> {c?.transactionId || 'N/A'}
        </p>
      )}
      <p>
        <strong>Course Available:</strong>{' '}
        {c?.isCourseAvailable
          ? 'User has access to the course'
          : 'User does not have access to the course'}
      </p>
      {'emailSent' in c && (
        <p>
          <strong>Expiry Email Sent:</strong>{' '}
          {c?.emailSent
            ? 'Expiry email has been sent'
            : 'Expiry email has not been sent'}
        </p>
      )}
      <p>
        <strong>Purchased Email Sent:</strong>{' '}
        {c?.purchaseEmailSent
          ? 'Purchased email has been sent'
          : 'Purchase email has not been sent'}
      </p>
      {c?.courseName?.includes('TDG') && (
        <>
          <p>
            <strong>Employer (TDG Only):</strong> {c?.employer || 'N/A'}
          </p>
          <p>
            <strong>Address (TDG Only):</strong> {c?.address || 'N/A'}
          </p>
        </>
      )}
    </>
  );
};

AdminOnlyDetails.propTypes = {
  c: PropTypes.shape({
    paid: PropTypes.bool,
    transactionId: PropTypes.string,
    isCourseAvailable: PropTypes.bool,
    emailSent: PropTypes.bool,
    purchaseEmailSent: PropTypes.bool,
    courseName: PropTypes.string,
    employer: PropTypes.string,
    address: PropTypes.string,
  }),
};

export default AdminOnlyDetails;
